import { Modal } from 'antd'
import { useNavigate } from 'react-router-dom'
import type { UseDeleteClientMutationResult } from '../../hooks'
import { useToast } from '@/contexts/ToastContext'
import { updateSession, useAuthSession } from '@/lib/session'

type DeleteClientModalProps = {
  open: boolean
  onClose: () => void
  clientId: string
  clientName?: string
  deleteMutation: UseDeleteClientMutationResult
}

export function DeleteClientModal({ open, onClose, clientId, clientName, deleteMutation }: DeleteClientModalProps) {
  const navigate = useNavigate()
  const { addToast } = useToast()
  const authSession = useAuthSession()

  const handleOk = async () => {
    try {
      await deleteMutation.mutateAsync(clientId)

      if (authSession?.currentClientId === clientId) {
        updateSession({
          currentClientId: '',
          currentClientName: '',
          currentClientTypeId: undefined,
          currentClientShowProjectStatus: undefined,
          currentClientShowAdvisoryMapping: undefined,
        })
      }

      addToast('Client deleted', 'warning')
      onClose()
      navigate('/clients')
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Unable to delete client'
      addToast(message, 'error')
    }
  }

  return (
    <Modal
      open={open}
      title="Delete client"
      okText="Delete"
      okButtonProps={{ danger: true, loading: deleteMutation.isPending }}
      onOk={() => void handleOk()}
      onCancel={onClose}
    >
      <p className="text-sm text-gray-700">
        Are you sure you want to delete <strong>{clientName}</strong>?
      </p>
    </Modal>
  )
}
